import React from "react";
import { Box, Stack, css, styled } from "@mui/material";
import { ReactComponent as PlatinumIcon } from "images/platinum.svg";
import { ReactComponent as GoldStartIcon } from "images/gold-start-icon.svg";
import { ReactComponent as SilverIcon } from "images/silver.svg";
import { ReactComponent as StarterIcon } from "images/starter.svg";
import { ReactComponent as BronzeIcon } from "images/bronze.svg";
import daimondIcon from "images/diamond.png";

export const Container = styled(Stack)`
  width: 100%;
  height: 100%;
  min-height: 667px;

  overflow: auto;
  justify-content: space-between;
`;

export const Header = styled(Stack)`
  padding: 4px 64px 4px 102px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: #fff;
`;

export const Content = styled(Stack)`
  padding: 39px;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  gap: 39px;

  background-color: #efefef;
  overflow: auto;

  @media (max-width: 800px) {
    
  }
`;

export const Profile = styled(Stack)`
  padding: 37px 46px;
  width: 233px;

  flex: 0 0 auto;
  align-items: center;
  gap: 10px;

  overflow: hidden;
  background-color: #fff;
  border-radius: 12px;
`;

export const TabContent = styled(Stack)`
  padding: 20px 26px;
  flex: 1 1 auto;
  border-radius: 12px;

  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const TabContentNoScroll = styled(Stack)`
  padding: 20px 26px;
  flex: 1 1 auto;
  border-radius: 12px;

  background-color: #fff;
  overflow: hidden;
`;

export const Navigation = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
`;

export const MenuItem = styled(Stack)`
  padding: 10px 24px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;

  font-family: sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  border-radius: 8px;

  cursor: pointer;
  user-select: none;

  &:hover {
    color: #272727;
  }
  &:hover rect,
  &:hover circle {
    stroke: #272727;
  }
  &:hover path {
    fill: #272727;
  }
`;

export const Inactive = css`
  color: #71839b;
  background-color: #fff;

  & rect,
  & circle {
    stroke: #71839b;
  }
  & path {
    fill: #71839b;
  }
`;

export const Active = css`
  color: #225da4;
  background-color: #f2f9ff;

  & rect,
  & circle {
    stroke: #225da4;
  }
  & path {
    fill: #225da4;
  }
`;

export const UserName = styled(Box)`
  margin-top: 10px;

  color: #000;
  text-align: center;
  font-family: sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Level = styled(Box)`
  margin-top: 5px;

  color: #2080d5;
  text-align: center;
  font-family: sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 27.248px; /* 151.38% */
  letter-spacing: -0.372px;
`;

export const LevelColorSx = {
  Starter: "#2080d5",
  Bronze: "#925f33",
  Silver: "#3e4c50",
  Gold: "#FFBD14",
  Platinum: "#679FAD",
};

export const LevelScaleFontColorSx = {
  Starter: "#2080d5",
  Bronze: "#925f33",
  Silver: "#3e4c50",
  Gold: "#D8990D",
  Platinum: "#679FAD",
};

export const LevelScaleColorSx = {
  Starter: "#C2E9FF",
  Bronze: "#FDD2AD",
  Silver: "#c9c9c9",
  Gold: "#FFEFBC",
  Platinum: "#c8d7db",
};

export const Prop = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`;

export const Label = styled(Box)`
  font-family: sans-serif;
  font-size: 16px;
  color: #9a9ea5;
`;

export const Value = styled(Box)`
  flex: 1 1 auto;
  font-family: sans-serif;
  font-size: 16px;
  color: #272727;
  text-align: left;
  overflow-wrap: anywhere;
  word-wrap: anywhere;
`;

export const ProgressBase = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 239px;
  height: 30px;
  border-radius: 15px;
`;

export const ProgressLevel = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  height: 30px;
  border-radius: 15px;
  font-family: sans-serif;
  font-weight: 500;
  color: white;
  // background-color: #7ecaf9;
`;

export const IconHolder = styled(Stack)`
  justify-content: center;
  align-items: center;

  // background-color: #fff;
  border-radius: 50%;
`;

export const AvatarHolder = styled(Stack)`
  justify-content: center;
  align-items: center;

  width: 114px;
  height: 114px;
  border-radius: 50%;
  background: radial-gradient(closest-side, white 92%, transparent 93% 100%),
    conic-gradient(
      ${({ 
      // @ts-ignore
      levelcolor }) => levelcolor} ${({ value }) => value}%,
      #ebebeb 0
    );
`;

export const StartIcon = {
  Starter: <StarterIcon />,
  Bronze: <BronzeIcon />,
  Silver: <SilverIcon />,
  Gold: <GoldStartIcon />,
  Platinum: <PlatinumIcon />,
};

export const EndIcon = {
  Starter: <BronzeIcon />,
  Bronze: <SilverIcon />,
  Silver: <GoldStartIcon />,
  Gold: <PlatinumIcon />,
  Platinum: <img width="27" height="20" src={daimondIcon} alt="Diamond" />,
};

const BIG_ICON_SIZE = "38px";

export const NewLevelIcon = {
  Starter: <StarterIcon width={BIG_ICON_SIZE} height={BIG_ICON_SIZE} />,
  Bronze: <BronzeIcon width={BIG_ICON_SIZE} height={BIG_ICON_SIZE} />,
  Silver: <SilverIcon width={BIG_ICON_SIZE} height={BIG_ICON_SIZE} />,
  Gold: <GoldStartIcon width={BIG_ICON_SIZE} height={BIG_ICON_SIZE} />,
  Platinum: <PlatinumIcon width={BIG_ICON_SIZE} height={BIG_ICON_SIZE} />,
};
